import { Injectable } from '@angular/core';

export const STORAGE_KEYS = {
  IS_BACKUP_SELECTED: 'isBackupSelected',
  LENDING_PREFERENCE_REMIND_ME_LATER: 'lendingPreferenceRemindMeLater',
  WELCOME_TOUR_SKIPPED: 'welcomeTourSkipped',
} as const;

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  get<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : fallback;
    } catch {
      return fallback;
    }
  }

  set(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  getRaw(key: string): string | null {
    return localStorage.getItem(key);
  }

  setRaw(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
}
